import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    // {
	// 	path: '/',
	// 	name: 'Home',
	// 	component: () => import(/* webpackChunkName: "Home" */ '@/Views/Home/'),
    // },
    {
        path: '/:userID/:productID', //634/13651
        alias: '/user/product',
        name: 'Product',
        props: true,
        component: () => import(/* webpackChunkName: "Product" */ '@/Views/Product/'),
        meta: {
            title: 'Facilita Corretor',
        },
    },
    {
        path: '/erro',
        alias: '*',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "NotFound" */ '@/Views/NotFound/'),
        meta: {
            title: 'Facilita Corretor',
        },
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    linkExactActiveClass: 'active',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})

export default router
